<template>
  <div class="p-3">
    <div class="d-flex">
      <div
        class="form-group mr-5 mt-1"
        v-for="item in translationSelectByDateOrYears()"
        :key="item.id"
        >
        <div class="form-check pl-0 pr-5">
          <label
            class="form-check-label pointer-clickable"
          >
            {{ item.name }}
          </label>
          <input
            v-model="selectedDateOrYears"
            class="form-check-input pointer-clickable ml-2"
            type="radio"
            :value="item.value"
            @change="changeRevenueAndProfitFilterType"
          />
        </div>
      </div>
    </div>
    <div class="d-flex align-items-center mb-2">
      <div class="card-label mr-2">{{ translations('dashboard.aggregate') }}</div>
      <div>
        <div class="dropdown">
          <button
            class="btn btn-outline-secondary dropdown-toggle"
            type="button"
            data-toggle="dropdown"
            aria-haspopup="true"
            aria-expanded="false"
          >
            {{ statistic }}
          </button>
          <div class="dropdown-menu">
            <a
              v-for="statis in statistics"
              :key="statis"
              class="dropdown-item"
              @click="clickStatistic(statis)"
            >
              {{ statis }}
            </a>
          </div>
        </div>
      </div>
    </div>
    <div class="d-flex align-items-center mb-2">
      <div class="card-label mr-2">{{ translations('common.period') }}</div>

      <div class="flex-grow-1">
        <DatePicker
          v-model="dateRange"
          value-type="format"
          format="YYYY/MM/DD"
          placeholder="yyyy/mm/dd ~ yyyy/mm/dd"
          class="date-range-field"
          range
          :editable="false"
          :clearable="false"
          :disabled="!!selectedDateOrYears"
        />
      </div>
    </div>
    <div class="d-flex align-items-center mb-2">
      <div class="card-label mr-2">{{ translations('dashboard.period') }}</div>
      <div class="dropdown">
        <button
          class="btn btn-outline-secondary dropdown-toggle"
          type="button"
          data-toggle="dropdown"
          aria-haspopup
          aria-expanded="false"
          :disabled="!selectedDateOrYears"
        >
          {{ selectedYear }}
        </button>
        <div class="dropdown-menu">
          <a
            v-for="yearOption in years"
            :key="yearOption.value"
            class="dropdown-item"
            @click="selectYear(yearOption)"
          >
            {{ yearOption.name }}
          </a>
        </div>
      </div>
    </div>
    <div class="d-flex align-items-center mb-2">
      <div class="card-label mr-2">{{ translations('dashboard.customer') }}</div>
      <div class="min-width-0 flex-grow-1 multiselect__wrap">
        <multiselect
          v-model="selectedClient"
          :options="customerOptions"
          multiple
          group-select
          group-values="libs"
          group-label="name"
          track-by="id"
          label="company"
          :placeholder="translations('dashboard.search_type')"
          selectLabel=""
          :selectedLabel="translations('dashboard.selected')"
          selectGroupLabel=""
          deselectLabel=""
          deselectGroupLabel=""
          :closeOnSelect="false"
          class="custom-multiselect"
          @open="openMenuClients"
          @close="closeMenuClients"
          >
            <span slot="noResult">{{ translations('dashboard.item_not_found') }} </span>
          </multiselect>
      </div>
    </div>
    <div class="d-flex align-items-center mb-2">
      <div class="card-label mr-2">{{ translations('dashboard.category') }}</div>
      <div class="min-width-0 flex-grow-1 multiselect__wrap">
        <multiselect
            v-model="selectedCategory"
            :options="categories"
            multiple
            group-select
            group-values="libs"
            group-label="name"
            track-by="id"
            label="name"
            :placeholder="translations('dashboard.search_type')"
            selectLabel=""
            :selectedLabel="translations('dashboard.selected')"
            selectGroupLabel=""
            deselectLabel=""
            deselectGroupLabel=""
            :closeOnSelect="false"
            :showPointer="!isHoverSelectAll"
            class="custom-multiselect"
            @open="openMenuCategories"
            @close="closeMenuCategories"
          >
            <li
              class="multiselect__element"
              slot="beforeList"
              @mouseover="isHoverSelectAll = true"
              @mouseout="isHoverSelectAll = false"
              @click="selectAllCategory"
            >
              <span
                class="multiselect__option multiselect__option--group"
                :class="{
                  'multiselect__option--highlight': isHoverSelectAll,
                  'multiselect__option--group-selected': isSelectedAllCategory
                }">{{ translations('dashboard.all') }}</span>
            </li>
            <span slot="noResult">{{ translations('dashboard.item_not_found') }} </span>
          </multiselect>
      </div>
    </div>
    <div class="form-group ml-10 mt-3">
      <button class="btn btn-primary btn-sm" type="button" @click="submitSearch" style="width: 70px;">{{ translations('common.search') }}</button>
    </div>
    <vue-element-loading :active="isSearching" />
  </div>
</template>

<script>
import Multiselect from 'vue-multiselect'
import VueElementLoading from 'vue-element-loading'
import DatePicker from '@/components/common/DatePicker'

import isEqual from 'lodash/isEqual'
import differenceWith from 'lodash/differenceWith'

import { RevenueAndProfitFilterType } from '@/constants'
import { mapState } from 'vuex'

export default {
  name: 'LineChartFilter',

  components: {
    Multiselect,
    VueElementLoading,
    DatePicker
  },

  props: {
    value: {
      type: Object,
      default: () => {}
    }
  },

  watch: {
    sessionParams (val) {
      this.$session.set('LineChartFilterParam', val)
    },

    tempFilterParams: {
      handler: 'fireSearch'
    }
  },

  async created () {
    this.isSearching = true
    await this.getListCustomers()
    await this.getListCategory()
    this.fireSearch()
    this.$emit('get-statistic', this.statistic)
    this.$emit('get-search', this.search)
    this.isSearching = false
  },

  data () {
    const {
      dateRange,
      statistic = '出荷数',
      selectedCategory = [],
      selectedClient = [],
      selectedDateOrYears = RevenueAndProfitFilterType.date,
      year = new Date().getFullYear(),
      search = false
    } = this.$session.get('LineChartFilterParam') || {}

    return {
      isSearching: false,
      isHoverSelectAll: false,
      statistic,
      search,
      statistics: ['売上額', '粗利額', '出荷数'],
      customers: [],
      categories: [],
      dateRange:
        dateRange || this.generateDateRangeByYear(new Date().getFullYear()),
      years: [
        { name: '今期', value: new Date().getFullYear() },
        { name: '前期', value: new Date().getFullYear() - 1 },
        { name: '前々期', value: new Date().getFullYear() - 2 }
      ],
      year,
      selectedCategory,
      tempSelectedCategory: [],
      selectedClient,
      tempSelectedClient: [],
      limit: 10000,
      page: 1,
      noOptionResultText: 'データが見つかりません。',
      selectedDateOrYears,
      selectByDateOrYears: [
        { id: 'date', name: 'カレンダー', value: RevenueAndProfitFilterType.date },
        { id: 'year', name: '期', value: RevenueAndProfitFilterType.year }
      ]
    }
  },

  computed: {
    ...mapState(['currentLanguage']),
    sessionParams () {
      return {
        year: this.year,
        dateRange: this.dateRange,
        statistic: this.statistic,
        selectedCategory: this.selectedCategory,
        selectedClient: this.selectedClient,
        selectedDateOrYears: this.selectedDateOrYears
      }
    },

    filterParams () {
      return {
        date_from: this.dateRange[0],
        date_to: this.dateRange[1],
        select_filter_type: this.selectedDateOrYears,
        year: this.year,
        customer_id:
          (!this.selectedClient.length || this.isSelectedAllClient) ? [] : this.selectedClient.map(client => Number(client.id)),
        category_ids:
          (!this.selectedCategory.length || this.isSelectedAllCategory) ? [] : this.selectedCategory.map(category => Number(category.id))
      }
    },

    tempFilterParams () {
      return {
        date_from: this.dateRange[0],
        date_to: this.dateRange[1],
        select_filter_type: this.selectedDateOrYears,
        year: this.year
      }
    },

    customerOptions () {
      let newData = this.customers.filter(function (obj) {
        return obj.shintaro_hidden_dashboard !== '1'
      })
      return [{ libs: [...newData], name: '全て' }]
    },

    selectedYear () {
      return this.years.find(({ value }) => value === this.year).name
    },

    flatCategory () {
      return this.categories.reduce((prevItem, curItem) => prevItem.concat(curItem.libs), [])
    },

    isSelectedAllCategory () {
      if (!this.selectedCategory.length) return false
      return !differenceWith(this.flatCategory, this.selectedCategory, isEqual).length
    },

    isSelectedAllClient () {
      if (!this.selectedClient.length) return false
      return !differenceWith(this.customers, this.selectedClient, isEqual).length
    }
  },

  methods: {
    translations (key) {
      const language = require(`@/locales/${this.currentLanguage}.json`)
      const keys = key.split('.')
      let value = language

      for (const k of keys) {
        value = value[k]
        if (!value) break
      }

      return value || key
    },

    clickStatistic (statistic) {
      this.statistic = statistic
      this.$emit('get-statistic', this.statistic)
    },

    async getListCustomers () {
      const params = {
        limit: this.limit,
        page: this.page
      }
      try {
        const response = await this.$http.get(this.$api_url.customers, { params })
        const { data, success } = response.data
        if (success) {
          this.customers = data
        }
      } catch (error) {}
    },

    async getListCategory () {
      try {
        const response = await this.$http.get(this.$api_url.categories)
        const { data, success } = response.data
        if (success) {
          this.categories = data
        }
      } catch (error) {}
    },

    fireSearch () {
      this.$emit('input', this.filterParams)
    },

    generateDateRangeByYear (year) {
      const currentDay = `${year}/02/01`
      const nextDay = `${year + 1}/01/31`
      return [
        currentDay,
        nextDay
      ]
    },

    selectYear (yearOption) {
      this.year = yearOption.value
      this.dateRange = this.generateDateRangeByYear(yearOption.value)
    },

    changeRevenueAndProfitFilterType () {
      if (this.selectedDateOrYears) {
        let getCurrentFilterYear = this.years.filter(year => year.value === this.year)
        this.selectYear(getCurrentFilterYear[0])
      }
    },

    selectAllCategory () {
      this.selectedCategory = this.isSelectedAllCategory ? [] : this.flatCategory
    },

    openMenuCategories () {
      this.tempSelectedCategory = [...this.selectedCategory]
    },

    openMenuClients () {
      this.tempSelectedClient = [...this.selectedClient]
    },

    closeMenuClients () {
      const isChangeSelect = Boolean(differenceWith(this.selectedClient, this.tempSelectedClient, isEqual).length) ||
        Boolean(differenceWith(this.tempSelectedClient, this.selectedClient, isEqual).length)
      if (isChangeSelect) this.fireSearch()
    },

    closeMenuCategories () {
      const isChangeSelect = Boolean(differenceWith(this.selectedCategory, this.tempSelectedCategory, isEqual).length) ||
        Boolean(differenceWith(this.tempSelectedCategory, this.selectedCategory, isEqual).length)
      if (isChangeSelect) this.fireSearch()
    },

    submitSearch () {
      this.search = true
      this.$emit('get-search', this.search)
    },

    translationSelectByDateOrYears () {
      return this.selectByDateOrYears.map(selectByDateOrYear => ({
        ...selectByDateOrYear,
        name: this.translations(`dashboard.${selectByDateOrYear.id}`)
      }))
    }
  }
}
</script>

<style scoped>
.dropdown-month {
  transform: translate3d(0px, -202px, 0px) !important;
}

.dropdown-customer {
  max-height: 200px;
  overflow: scroll;
}

.card-label {
  min-width: 70px;
}

.unit-item-text {
  display: inline-block;
  max-width: 30px;
  text-align: end;
  width: 100%;
}

.date-range-field {
  max-width: 215px;
  width: 100%;
}

.min-width-0 {
  min-width: 0;
}

/* Begin - custom v-select */
.custom-v-select >>> .vs__dropdown-toggle {
  width: 100%;
  min-width: 0;
}

.custom-v-select >>> .vs__selected-options {
  flex: 1;
  min-width: 0;
  align-items: center;
}

.custom-v-select >>> .vs__selected {
  display: block;
  flex: 1;
  overflow: hidden;
  white-space: nowrap;
  text-overflow: ellipsis;
  width: 100%;
  min-width: 0;
  color: #6c757d;
}

.custom-v-select.vs--open >>> .vs__selected {
  display: none;
}

.custom-v-select >>> .vs--single.vs--open .vs__selected {
  display: none;
}

.custom-v-select >>> .vs__search {
  flex-grow: 0;
}

.custom-v-select.vs--open >>> ul {
  right: 0;
  left: auto;
  border-top-style: solid;
  border-radius: 4px;
  min-width: 100%;
}

.custom-v-select >>> .vs__open-indicator {
  transform: scale(0.7);
  color: #6c757d;
}

.custom-v-select >>> .vs__search {
  padding: 0 1px;
}

.custom-v-select >>> .vs__search:focus {
  padding: 0 10px;
}

.custom-v-select >>> .vs__dropdown-option {
  color: #6c757d;
}

.custom-v-select >>> .vs__dropdown-option--highlight {
  background: #f5f5f5;
  color: #6c757d;
}
/* End - custom v-select */

/* Begin - custom multiselect */
.custom-multiselect {
  margin-left: 0;
  width: 100%;
}

.custom-multiselect >>> .multiselect__tags {
  border-color: #cdcdcd;
}

.custom-multiselect >>> .multiselect__option {
  display: flex;
  align-items: center;
  justify-content: space-between;
  height: 40px;
}

.custom-multiselect >>> .multiselect__option--selected::after {
  position: relative;
  min-width: 84px;
}
/* End - custom multiselect */
</style>
